import { useTranslation } from 'react-i18next';
import { RFQStatus, formatDateTime } from '@steelbuy/ts-shared';
import { getBadgeVariant, getQuoteStatusBadgeVariant } from '@steelbuy/ui-domain';
import { Card, CardContentListingViewState, CardLayout, Notification, NotificationLevel } from '@steelbuy/ui-primitive';

export const CardContentStatus = ({
    status,
    expiresAt,
    isRequestQuote,
}: {
    status: RFQStatus;
    expiresAt: string;
    isRequestQuote?: boolean;
}) => {
    const { t } = useTranslation('translation');

    return (
        <Card isClickable={false}>
            <CardLayout>
                <CardContentListingViewState
                    header={
                        isRequestQuote
                            ? t(`application.myQuotes.statusText.header.${status}`)
                            : t(`application.myRFQ.statusText.header.${status}`)
                    }
                    date={formatDateTime(new Date(expiresAt)).split(' ').join(', ')}
                    badgeVariant={isRequestQuote ? getQuoteStatusBadgeVariant(status) : getBadgeVariant(status)}
                    badgeLabel={
                        isRequestQuote
                            ? t(`application.myQuotes.rfqStatus.${status}`)
                            : t(`application.myRFQFilter.optionLabels.${status}`)
                    }
                />
                {status === RFQStatus.EXPIRED && (
                    <Notification
                        level={NotificationLevel.INFO}
                        message={t('application.myRFQDetails.notificationMsg')}
                    />
                )}
            </CardLayout>
        </Card>
    );
};
